import { Inquiry } from "@robe/core-types/inquiry";
import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";

export const getInquiries = (core: XcoreCore): BaseApiRequest<Inquiry[]> => core.fetch("/api/inquiry").then((res) => res.json());
